import shopifyGenericDefaults from '../shopify-warehouse-generic/config.js';

export default {
  ...shopifyGenericDefaults,
  includes: ['shopify-warehouse-generic'],
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (w) => !['VehicleWidgetDialog', 'VerifyFitment'].includes(w.name),
    ),
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: '#cm_vehicle-widget__home',
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 900,
    },
    {
      name: 'VerifyFitment',
      location: '#cm-verify-fitment',
      template: 'fitmentSearch/collapsibleVerifyFitment',
      isAlwaysColumnLayout: true,
      initCollapsed: true,
    },
    {
      name: 'VehicleWidgetDialog',
      location: { class: 'vehicle-dialog' },
      template: 'fitmentSearch/dialog',
      fields:
        !!window.Convermax.config?.extraFieldsAsFilters && shopifyGenericDefaults.fitmentSearch.baseFields,
      globalVehicleDiscardEnabled: true,
      isAlwaysColumnLayout: true,
    },
  ],
};
